export enum User {
    info = 'USER-INFO',
    token = 'USER-TOKEN'
}